import { render, staticRenderFns } from "./IconBox.vue?vue&type=template&id=3dbacb52&scoped=true&"
var script = {}
import style0 from "./IconBox.vue?vue&type=style&index=0&id=3dbacb52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbacb52",
  null
  
)

export default component.exports